/** URL helpers for embedded launcher iframes. Lobby ↔ launcher IPC uses WebWrapper RPC only. */

import { ddRumError } from '@/utils/datadog';
import { GAME_PLAY_PATH_PREFIX } from '@/utils/url/game-play-path';

const copyPathGameUidToSearchParams = (source: URL, target: URL, pathPrefix: string): void => {
    if (target.searchParams.has('gameUid')) {
        return;
    }

    const pathname = source.pathname.replace(/\/$/, '');
    const prefix = `${pathPrefix}/`;

    if (!pathname.startsWith(prefix) || pathname.length <= prefix.length) {
        ddRumError({
            name: 'Invalid pathname',
            description: 'Invalid pathname',
            context: {
                pathname,
                prefix,
                error: new Error('Invalid pathname')
            },
            use_case: 'GLOBAL'
        });
        return;
    }

    const pathGameUid = pathname.slice(prefix.length);

    if (pathGameUid && !pathGameUid.includes('/')) {
        target.searchParams.set('gameUid', pathGameUid);
    }
};

export const appendEmbeddedQueryParam = (launcherUrl: string): string => {
    const url = new URL(launcherUrl, window.location.origin);
    url.searchParams.set('embedded', '1');
    return url.toString();
};

export const buildDetachedLauncherUrl = (
    transferId: string,
    sourceLauncherUrl?: string | null,
    pathPrefix: string = GAME_PLAY_PATH_PREFIX
): string => {
    const url = new URL(`${window.location.origin}${pathPrefix}/`);

    if (sourceLauncherUrl) {
        try {
            const source = new URL(sourceLauncherUrl, window.location.origin);
            source.searchParams.forEach((value, key) => {
                if (key !== 'embedded' && key !== 'mode' && key !== 'transferId') {
                    url.searchParams.set(key, value);
                }
            });
            copyPathGameUidToSearchParams(source, url, pathPrefix);
        } catch {
            // Ignore invalid launcher URLs and fall back to the base detached route.
        }
    }

    url.searchParams.set('mode', 'detached');
    url.searchParams.set('transferId', transferId);
    return url.toString();
};
